import axios from 'axios'
import { API_URL } from '../../../../constants'
import { EmployeeProfile } from '../core/_models'

export interface IEmployeeProfileRes {
  success: boolean
  data: EmployeeProfile | null
  totalRows?: number
}

export const getEmployeeProfile = (uuid: string) =>
  axios.get<IEmployeeProfileRes>(
    `${API_URL}/api/internal/employee/profile/${encodeURIComponent(uuid)}`
  )
